import { store } from '../store';
import { locateCustomer } from '../actions/customer';

export const restoreLocation = () => {
  let location = localStorage.getItem('location');

  if (!location) return false;

  store.dispatch(
    locateCustomer(JSON.parse(location))
  );

  return JSON.parse(location);
}



// WEBPACK FOOTER //
// ./src/utils/restore-from-state.js